import { Injectable } from '@angular/core';

export interface CollaboraMessage {
  MessageId?: string;
  Values?: any;
}

@Injectable({ providedIn: 'root' })
export class CollaboraMessageService {
  constructor() { }

  parseMessage(event: MessageEvent, allowedOrigins?: string[]): CollaboraMessage | null {
    if (allowedOrigins && allowedOrigins.length > 0 && !allowedOrigins.includes(event.origin)) {
      return null;
    }

    let msg: any;
    try {
      if (typeof event.data === 'string') {
        msg = JSON.parse(event.data);
      } else {
        msg = event.data;
      }
    } catch (e) {
      return null;
    }

    if (msg && typeof msg === 'object') {
      return msg as CollaboraMessage;
    }
    return null;
  }

  getTargetOrigin(collaboraUrl?: string): string {
    if (!collaboraUrl) return '*';
    try {
      const u = new URL(collaboraUrl);
      return u.origin;
    } catch (e) {
      return '*';
    }
  }

  sendMessage(contentWindow: Window | null, messageId: string, params?: any, collaboraUrl?: string): void {

    if (!contentWindow) return;

    const message = {
      MessageId: messageId,
      SendTime: Date.now(),
      Values: params || {}
    };

    const targetOrigin = this.getTargetOrigin(collaboraUrl);
    try {
      contentWindow.postMessage(JSON.stringify(message), targetOrigin);
    } catch (e) {
      console.warn('Failed to postMessage', e);
    }
  }

}
